import { DeepPartial, OpenConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_OPEN: DeepPartial<OpenConfig> = { triggersSelector: '.buscador', components: { open: 'CdlOpen' } };
